import { useTranslation } from '@mint-lib/i18n';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  userName?: string;
  className?: string;
};

const UserGreeting = ({ userName, className }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <p
        style={{ fontWeight: 510 }}
        className="flex bg-linear-to-tr from-ai-lightCyan to-ai-lightGreen bg-clip-text text-[32px] leading-10 text-transparent"
      >
        {t('Hi {{name}}', { name: userName })}
      </p>

      <p
        style={{ fontWeight: 510 }}
        className="flex bg-linear-to-tr from-ai-lightCyan to-ai-lightGreen bg-clip-text text-[32px] leading-10 whitespace-nowrap text-transparent"
      >
        {t(`how can I help today?`)}
      </p>
    </div>
  );
};

export { UserGreeting };
